// SPDX-License-Identifier: Apache-2.0
import type { MedplumClient } from '@medplum/core';

/**
 * Is the signed-in member allowed to change practice settings (the Admin surface)?
 *
 * True only for a project admin (or a super admin). Hiding Admin from everyone else is a UI
 * convenience — the real protection is the clinician AccessPolicy on the server (see
 * `buildClinicalAccessPolicy` / `create-demo-provider.mjs`), which rejects a non-admin's write to the
 * practice-settings resources with 403 regardless of what the UI shows (#142).
 */
export function isPracticeAdmin(medplum: MedplumClient): boolean {
  return medplum.isProjectAdmin() || medplum.isSuperAdmin();
}
